import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';

/**
 * Unauthorized — Shown when a user is authenticated but lacks the required
 * role to access a specific route (403-equivalent page).
 */
const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        gap: 2,
        textAlign: 'center',
        px: 3,
      }}
    >
      <Box sx={{ bgcolor: 'error.lighter', borderRadius: '50%', p: 2.5, display: 'flex' }}>
        <LockOutlinedIcon sx={{ fontSize: 56, color: 'error.main' }} />
      </Box>
      <Typography variant="h4" fontWeight={800} color="text.primary">
        Acceso Denegado
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420 }}>
        No tienes permisos para acceder a esta sección. Contacta al administrador si crees que esto es un error.
      </Typography>
      <Button
        variant="contained"
        size="large"
        onClick={() => navigate(-1)}
        sx={{ mt: 2, borderRadius: 2, px: 4, fontWeight: 600 }}
      >
        Volver
      </Button>
    </Box>
  );
};

export default Unauthorized;
